import { DropdownItemProps } from "semantic-ui-react";

export const GET_JUSTIFICATIONS = "GET_JUSTIFICATIONS";
export const ADD_JUSTIFICATION = "ADD_JUSTIFICATION";
export const REMOVE_JUSTIFICATION = "REMOVE_JUSTIFICATION";

export const GetJustifications = () => {
    return { type: GET_JUSTIFICATIONS };
};

export const AddJustification = (justProp: DropdownItemProps) => {
    return { type: ADD_JUSTIFICATION, justProp };
};

export const RemoveJustification = (justProp: DropdownItemProps) => {
    return { type: REMOVE_JUSTIFICATION, justProp };
};
